import type { TourTargetCatalogEntry } from './types'

/** Targets for the `setup-store-logo` virtual tour. */
export const SETUP_STORE_LOGO_TOUR_TARGETS = {
  settingsHeading: {
    key: 'settingsHeading',
    route: '/app/settings',
    matchPaths: ['/app/settings', '/app/settings/invoice_setting'],
    selector: '[data-tour="settings-heading"]',
    description: 'Settings page title heading (Invoice settings tab)',
    featureArea: 'Settings',
    waitTimeoutMs: 12000,
  },
  settingsStoreTab: {
    key: 'settingsStoreTab',
    route: '/app/settings',
    matchPaths: ['/app/settings', '/app/settings/invoice_setting', '/app/settings/store'],
    selector: '[data-tour="settings-tabs"] #store[role="tab"]',
    description: 'Store settings tab in the settings tab bar (visible tab, not TabMeasurer)',
    featureArea: 'Settings',
    waitTimeoutMs: 12000,
    interactionMode: 'interactive',
    advanceOnPath: '/app/settings/store',
    advanceOnPathMatch: 'exact',
  },
  storeLogoSetting: {
    key: 'storeLogoSetting',
    route: '/app/settings/store',
    selector: '[data-tour="store-change-logo"]',
    description: 'Change Logo / Select Logo button on store settings',
    featureArea: 'Settings',
    waitTimeoutMs: 30_000,
    advanceOnClick: '[data-tour="store-change-logo"]',
  },
} as const satisfies Record<string, TourTargetCatalogEntry>

export type SetupStoreLogoTourTargetKey = keyof typeof SETUP_STORE_LOGO_TOUR_TARGETS

export const SETUP_STORE_LOGO_TOUR_TARGET_KEY = {
  settingsHeading: 'settingsHeading',
  settingsStoreTab: 'settingsStoreTab',
  storeLogoSetting: 'storeLogoSetting',
} as const satisfies { readonly [K in SetupStoreLogoTourTargetKey]: K }
